exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".col.p-0[data-v-0ede6276]{margin-right:10px}.btn.btn-primary[data-v-0ede6276]{margin:2rem auto}", ""]);

// exports
